export const ActiveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
    <circle cx="15" cy="15" r="15" fill="#009444"/>
    <path d="M21.75 12.2188C22.0625 12.5312 22.0625 13 21.75 13.2812L13.5 21.5312C13.2188 21.8438 12.75 21.8438 12.4688 21.5312L8.21875 17.2812C7.90625 17 7.90625 16.5312 8.21875 16.2188C8.5 15.9375 8.96875 15.9375 9.25 16.2188L13 19.9688L20.7188 12.2188C21 11.9375 21.4688 11.9375 21.75 12.2188Z" fill="white"/>
  </svg>
);
